import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body pb-0 pl-1 pt-0" }
const _hoisted_2 = { class: "row form-group" }
const _hoisted_3 = { class: "col-lg-4 col-md-4 col-sm-6 form-control no-border" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-0 small text-muted mb-2" }, "cheked", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createBlock(_component_q_form, { ref: "DocumentBRForm" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_q_toggle, {
              size: "xl",
              "checked-icon": "check",
              "unchecked-icon": "clear",
              class: "my-more-fancy-toggle q-mt-xs q-ml-xs-q-inline pl-0",
              color: "primary",
              modelValue: _ctx.intBRRule.checked,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.intBRRule.checked) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeBR($event)))
              ]
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 512))
}